import { render, staticRenderFns } from "./NotifyCard.vue?vue&type=template&id=49680eed"
import script from "./NotifyCard.vue?vue&type=script&lang=js"
export * from "./NotifyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports